import React from 'react';

import { Col, Form, Modal, Row } from 'antd';
import { Button, Input, Typography } from 'components';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as loginService from 'services/login.service';
import { customMessages, customValidators } from 'utils';

import { loginEvents } from 'utils/utility-functions';

import formatter from 'string-format';
const { Link } = Typography;

const LoginForm2 = ({ msisdn }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  function login(values) {
    loginService
      .login(values)
      .then((res) => {
        dispatch({
          type: 'PRE_LOGIN',
          payload: res,
        });
        history.push(`/Login/${values.msisdn}/otp`);
      })
      .catch((response) => {
        let errorMessage = customMessages.getMessage(response.responseCode);
        if (response.responseCode) {
          try {
            errorMessage = formatter(
              errorMessage,
              response.maxInvalidPassCount,
              response.currentInvalidPassCount
            );
          } catch (error) {}
        }
        Modal.error({
          title: 'Hata',
          content: errorMessage,
        });
        loginEvents(values.msisdn, 'Failure', response.responseCode);
      });
  }

  const receiveMessage = (event) => {
    event.preventDefault();
    window.removeEventListener('message', (event) => receiveMessage(event));

    const { data } = event;
    if (data === undefined || data === null) {
      return;
    }
    const result = JSON.parse(unescape(data));
    if (result.responseCode == 200) {
      dispatch({
        type: 'LOGIN',
        payload: result,
      });
      history.push({
        pathname: `/ReportsPage`,
      });
    } else {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(result.responseCode),
      });
    }

    window.removeEventListener('message', receiveMessage, false);
  };

  return (
    <>
      <h3 className="section__title">Giriş Yap</h3>
      <Row className="margin-bottom-spacing-m">
        <p className="info-text--big">
          Telefon numaranız ve şifreniz ile giriş yapın.
        </p>
      </Row>
      <Form
        form={form}
        name="login"
        initialValues={{ msisdn }}
        onFinish={(values) => {
          login(values);
        }}
        onFinishFailed={() => {}}
      >
        <Form.Item
          name="msisdn"
          messageVariables={{ label: 'GSM Numarası' }}
          rules={[
            { required: true, validator: customValidators.isMsisdn },
            {
              pattern: /^\d{10}$/,
              message: 'must be a valid phone number',
            },
          ]}
        >
          <Input
            autoComplete="off"
            label="GSM Numaranız"
            maxLength={10}
            disabled={!!msisdn}
          />
        </Form.Item>

        <Form.Item
          name="password"
          messageVariables={{ label: 'Şifre' }}
          rules={[{ required: true }]}
        >
          <Input.Password autoComplete="new-password" label="Şifreniz" />
        </Form.Item>
        <Row flex justify="end" className="margin-bottom-spacing-s">
          <Link to="/ForgotPasswordPage">Şifremi unuttum</Link>
        </Row>
        <Form.Item>
          <Row gutter={16}>
            <Col xs={9} sm={12}>
              <Button type="ghost" onClick={() => history.push('/Login')} block>
                Geri
              </Button>
            </Col>
            <Col xs={15} sm={12}>
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                className="login-button"
                block
              >
                Giriş Yap
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm2;
